import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../components/shared/Header/Header';
import Newsletter from '../../components/shared/Footer/Newsletter';
import Footer from '../../components/shared/Footer/Footer';
import RequestForCustomization from '../../components/CustomizationReqModal';
import WhatsAppFloatButton from '../../components/shared/WhatsAppFloatButton';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { FiSearch } from 'react-icons/fi';
import { FaListUl, FaTimes } from 'react-icons/fa';
import ServiceCard from '../../components/cards/ServiceCard';
import ProductDetailsPopupWithCount from '../../components/ProductDetailsPopupWithCount';
import { getAllExtras } from '../../api/extras.service';
import { getAllCartItems } from '../../api/cart.service';
import MobileButtons from '../../components/MobileButtons';
import { motion } from 'framer-motion';

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (custom = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.1,
      duration: 0.5,
      ease: 'easeOut',
    },
  }),
};

const popIn = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.4, ease: 'easeOut' },
  },
};

const scaleHover = {
  hover: { scale: 1.05, transition: { duration: 0.3, ease: 'easeOut' } },
};
const ExtrasMakeup = () => {
  const [extras, setExtras] = useState([]);
  const [filteredExtras, setFilteredExtras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [extraLoading, setExtraLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('');
  const [extraCategory, setExtraCategory] = useState('');
  const [extrasType, setExtrasType] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [displayCount, setDisplayCount] = useState(8);
  const [selectedExtras, setSelectedExtras] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [categories, setCategories] = useState([]);
  const [cartItems, setCartItems] = useState([]);

  const eventFormState = useSelector((state) => state.form);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location;
  console.log('state: ', state);

  const [vendorCarouselIndex, setVendorCarouselIndex] = useState(0);
  const visibleVendors = 6;

  const fetchExtrasData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAllExtras();
      if (response.success) {
        const fetchedExtras = response.data;
        setExtras(fetchedExtras);
        setFilteredExtras(fetchedExtras);

        const uniqueCategories = [
          ...new Map(
            fetchedExtras.map((extra) => [
              extra.category?.id,
              {
                id: extra.category?.id,
                name: extra.category?.name,
                image_urls: extra.category?.image_urls,
              },
            ])
          ).values(),
        ];
        setCategories(uniqueCategories);
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError('Failed to fetch extras');
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCartItems = async () => {
    try {
      const response = await getAllCartItems();
      if (response.success && response.data?.items) {
        setCartItems(response.data.items);
      }
    } catch (error) {
      console.error('Error fetching cart items:', error);
    }
  };

  useEffect(() => {
    fetchExtrasData();
    fetchCartItems();
  }, [fetchExtrasData]);

  useEffect(() => {
    if (
      state?.fromCartEdit &&
      state?.isExtras?.isExtras?.itemDetails?.item_id &&
      extras.length > 0
    ) {
      const extraItem = extras.find(
        (item) => item.id === state.isExtras.isExtras.itemDetails.item_id
      );
      if (extraItem && extraItem.category?.id) {
        setExtraCategory(extraItem.category.id);
      }
    }
  }, [extras, state]);

  useEffect(() => {
    let results = [...extras];

    if (extraCategory) {
      results = results.filter((extra) => extra.category?.id === extraCategory);
    }
    if (extrasType) {
      results = results.filter((extra) => extra.sub_category === extrasType);
    }

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      results = results.filter(
        (extra) =>
          extra.name?.toLowerCase().includes(searchLower) ||
          extra.description?.toLowerCase().includes(searchLower)
      );
    }

    if (sortBy) {
      results.sort((a, b) => {
        if (sortBy === 'price_low_high') return a.price - b.price;
        if (sortBy === 'price_high_low') return b.price - a.price;
        if (sortBy === 'name_a_z')
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        if (sortBy === 'name_z_a')
          return b.name.localeCompare(a.name, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        return 0;
      });
    }


    const withCart = results.filter((extra) =>
      cartItems.some(
        (item) => item.item_id === extra.id && item.item_type === 'extras'
      )
    );
    const withoutCart = results.filter(
      (extra) =>
        !cartItems.some(
          (item) => item.item_id === extra.id && item.item_type === 'extras'
        )
    );
    results = [...withCart, ...withoutCart];

    setFilteredExtras(results);
  }, [extras, searchTerm, sortBy, extrasType, extraCategory, cartItems]);

  const handleVendorSelect = (category) => {
    setExtraCategory(category);
  };

  const nextVendorSlide = () => {
    setVendorCarouselIndex((prevIndex) =>
      prevIndex === categories.length - visibleVendors ? 0 : prevIndex + 1
    );
  };

  const prevVendorSlide = () => {
    setVendorCarouselIndex((prevIndex) =>
      prevIndex === 0 ? categories.length - visibleVendors : prevIndex - 1
    );
  };

  const displayedVendors = categories.slice(
    vendorCarouselIndex,
    vendorCarouselIndex + visibleVendors
  );

  const renderExtras = () => {
    if (!extraCategory) {
      return (
        <div className='p-4 mt-10 shadow-[rgba(6,_24,_44,_0.4)_0px_0px_0px_2px,_rgba(6,_24,_44,_0.65)_0px_4px_6px_-1px,_rgba(255,_255,_255,_0.08)_0px_1px_0px_inset] w-full max-w-xl mx-auto rounded-lg'>
          <h1
            className='text-center font-bold'
            style={{ fontSize: 'clamp(1rem, 2vw + 0.8rem, 1.3rem)' }}
          >
            Please, select the categories to display
          </h1>
        </div>
      );
    }

    if (extraLoading) {
      return (
        <div className='flex justify-center items-center '>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-buttonhoverPrimary'></div>
        </div>
      );
    }

    const displayedExtras = filteredExtras.slice(0, displayCount);

    if (displayedExtras.length === 0) {
      if (extrasType === 'Combo') {
        return (
          <div className='p-4 mt-10  w-full max-w-7xl mx-auto rounded-lg'>
            <h1 className='text-center font-bold text-xl'>Coming Soon!</h1>
            <p className='text-center mt-2'>
              We're working hard to curate an exceptional collection of items
              that perfectly capture your event’s spirit. Please check back soon
              for exciting updates!
            </p>
          </div>
        );
      } else {
        return (
          <div className='p-4 mt-10 w-full max-w-7xl mx-auto rounded-lg'>
            <h1 className='text-center font-bold'>No results available.</h1>
            <p className='text-center mt-2'>
              We're working hard to curate an exceptional collection of items
              that perfectly capture your event’s spirit. Please check back soon
              for exciting updates!
            </p>
          </div>
        );
      }
    }

    return (
      <motion.div
        variants={staggerContainer}
        initial='hidden'
        animate='visible'
      >
        <div className='grid grid-cols-1 mt-8 md:grid-cols-1 lg:grid-cols-2 md:gap-8 gap-3 w-full m-auto'>
          {displayedExtras.map((extra, index) => (
            <motion.div
              key={extra.id}
              variants={fadeInUp}
              custom={index}
              className='cursor-pointer'
              onClick={() => setSelectedExtras(extra)}
            >
              <ServiceCard
                key={extra.id}
                id={extra.id}
                image={extra.image_urls}
                title={extra.name}
                items={extra.items}
                price={extra.price}
                quantity={extra.quantity || 0}
                cart_id={extra.cart_id}
                type='extras'
                nextPage='event-coverages'
                description={extra.description}
                details={extra.details}
                cartItems={cartItems}
              />
            </motion.div>
          ))}
        </div>
      </motion.div>
    );
  };

  if (loading) {
    return (
      <div className='flex justify-center items-center h-screen'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-buttonhoverPrimary'></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='flex justify-center items-center h-screen text-red-500'>
        {error}
      </div>
    );
  }

  return (
    <div>
      <Header />
      <main className='container mx-auto px-6 md:px-4 py-8'>
        <section>
          <div>
            <div className='flex items-center mb-4 justify-between'>
              <button
                onClick={() => navigate('/return-gifts')}
                className='flex items-center gap-1 sm:gap-2 sm:block hidden hover:text-[#DF695E] transition-colors'
              >
                <span className='font-medium text-sm sm:text-base'>Back</span>
              </button>
              <button
                onClick={() => navigate('/cart')}
                className='text-gray-600 hover:text-gray-900 sm:block hidden'
              >
                Next
              </button>
            </div>

            <div className='fixed inset-x-0 bottom-6 z-50 sm:hidden'>
              <MobileButtons
                onBack={() => navigate('/return-gifts')}
                onNext={() => navigate('/cart')}
              />
            </div>

            <h1 className='text-3xl font-bold mb-2'>Extras Page </h1>
            <p className='text-gray-700 mb-6 ml-1'>
              Select the extras subcategories with muliple select options.
            </p>

            {categories.length > visibleVendors ? (
              <div className='relative'>
                <button
                  onClick={prevVendorSlide}
                  className='absolute left-0 top-1/2 -translate-y-1/2 -ml-4 z-10 bg-white rounded-full shadow-md p-2'
                  aria-label='Previous vendors'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-6 w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M15 19l-7-7 7-7'
                    />
                  </svg>
                </button>

                <div className='flex gap-2 md:gap-4 w-full justify-between lg:w-[95%] mx-auto items-center overflow-x-auto whitespace-nowrap no-scrollbar'>
                  {displayedVendors.map((category, index) => (
                    <motion.div
                      key={category.id}
                      className={`flex flex-col items-center shrink-0 cursor-pointer p-1 transition-opacity duration-200 ${
                        extraCategory === category.id
                          ? 'opacity-100'
                          : 'opacity-90 hover:opacity-95'
                      }`}
                      onClick={() => handleVendorSelect(category.id)}
                      variants={fadeInUp}
                      custom={index}
                    >
                      <div
                        className={`rounded-full overflow-hidden mb-3
                          w-24 h-24 sm:w-32 sm:h-32 md:size-[7.5rem]
                          flex items-center justify-center
                          ${
                            extraCategory === category.id
                              ? 'border-2 border-[#4A628A] shadow-[0px_0px_3px_2px_rgba(19,40,217)]'
                              : 'border-2 border-gray-200'
                          }`}
                      >
                        <img
                          src={category?.image_urls?.url}
                          alt={category.name}
                          className='w-full h-full object-cover'
                        />
                      </div>
                      <p className='text-center md:text-base text-sm'>
                        {category.name}
                      </p>
                    </motion.div>
                  ))}
                </div>

                <button
                  onClick={nextVendorSlide}
                  className='absolute right-0 top-1/2 -translate-y-1/2 -mr-4 z-10 bg-white rounded-full shadow-md p-2'
                  aria-label='Next vendors'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-6 w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M9 5l7 7-7 7'
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <div className='flex gap-2 md:gap-4 w-full lg:w-[95%] justify-start mx-auto items-center overflow-x-auto whitespace-nowrap no-scrollbar pl-2'>
                {categories.map((category) => (
                  <div
                    key={category.id}
                    className={`flex flex-col items-center shrink-0 cursor-pointer p-1 ${
                      extraCategory === category.id
                        ? 'opacity-100'
                        : 'opacity-90 hover:opacity-95'
                    } transition-opacity duration-200`}
                    onClick={() => handleVendorSelect(category.id)}
                  >
                    <div
                      className={`rounded-full overflow-hidden mb-3
                        w-24 h-24 sm:w-32 sm:h-32 md:size-[7.5rem]
                        flex items-center justify-center
                        ${
                          extraCategory === category.id
                            ? 'border-2 border-[#4A628A] shadow-[0px_0px_3px_2px_rgba(19,40,217)]'
                            : 'border-2 border-gray-200'
                        }`}
                    >
                      <img
                        src={category?.image_urls?.url}
                        alt={category.name}
                        className='w-full h-full object-cover'
                      />
                    </div>
                    <p className='text-center md:text-base text-sm'>
                      {category.name}
                    </p>
                  </div>
                ))}
              </div>
            )}

            <h1 className='text-3xl font-bold mt-12 mb-2'>Extras Items</h1>
            <p className='text-gray-700 mb-6 ml-1'>
              Select the items for your event based on your requirements.
            </p>
          </div>
          <div className='flex flex-col gap-4 mb-6 w-full'>
            <div className='hidden lg:flex justify-between items-center'>
              <div className='flex gap-3'>
                <div className='flex flex-wrap gap-3'>
                  <select
                    className='w-40 pl-2 py-1 bg-white rounded-full text-black focus:outline-none border border-gray-300 text-sm'
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value=''>Sort by</option>
                    <option value='name_a_z'>Name: A to Z</option>
                    <option value='name_z_a'>Name: Z to A</option>
                    <option value='price_low_high'>Price: Low to High</option>
                    <option value='price_high_low'>Price: High to Low</option>
                  </select>{' '}
                  <select
                    value={extrasType}
                    onChange={(e) => setExtrasType(e.target.value)}
                    className='w-32 pl-2 py-1 bg-white rounded-full text-black focus:outline-none border border-gray-300 text-sm'
                  >
                    <option value=''>Type</option>
                    <option value='Single'>Single</option>
                    <option value='Combo'>Combo</option>
                  </select>
                </div>
                <SearchBar onSearch={setSearchTerm} />
              </div>
              <RequestForCustomization sectionName={'Extras'} />
            </div>

            <div className='hidden md:flex lg:hidden flex-col gap-3'>
              <div className='flex flex-wrap items-center justify-between gap-3'>
                <div className='flex gap-2'>
                  <select
                    className='w-40 pl-2 py-1 bg-white rounded-full text-black focus:outline-none border border-gray-300 text-sm'
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value=''>Sort by</option>
                    <option value='name_a_z'>Name: A to Z</option>
                    <option value='name_z_a'>Name: Z to A</option>
                    <option value='price_low_high'>Price: Low to High</option>
                    <option value='price_high_low'>Price: High to Low</option>
                  </select>
                  <select
                    value={extrasType}
                    onChange={(e) => setExtrasType(e.target.value)}
                    className='w-32 pl-2 py-1 bg-white rounded-full text-black focus:outline-none border border-gray-300 text-sm'
                  >
                    <option value=''>Type</option>

                    <option value='Single'>Single</option>
                    <option value='Combo'>Combo</option>
                  </select>
                </div>
                <div className='w-[50%]'>
                  <SearchBar onSearch={setSearchTerm} />
                </div>
              </div>
              <RequestForCustomization sectionName={'Extras'} />
            </div>

            <div className='relative flex flex-col gap-3 md:hidden'>
              <div className='flex gap-2 items-center'>
                <button
                  className='w-[8rem] py-1 bg-white rounded-full text-black border border-gray-300 text-sm flex items-center gap-3 px-4'
                  onClick={() => setShowFilters(!showFilters)}
                >
                  <span>
                    {' '}
                    <FaListUl />
                  </span>
                  Filters
                </button>

                <SearchBar onSearch={setSearchTerm} />
              </div>

              {showFilters && (
                <div className='absolute top-6 left-1 mt-2 w-[70%] z-10 bg-white shadow-md rounded-lg p-4 flex flex-col gap-3 border border-gray-300'>
                  <button
                    onClick={() => setShowFilters(false)}
                    className='absolute top-3 right-3 text-gray-500'
                  >
                    <FaTimes />
                  </button>

                  <div>
                    <label className='text-sm font-semibold'>Sort By</label>
                    <select
                      className='w-full mt-1 pl-2 py-1 bg-white rounded-md border border-gray-300 text-black text-sm'
                      value={sortBy}
                      onChange={(e) => {
                        setSortBy(e.target.value);
                      }}
                    >
                      <option value=''>Sort by</option>
                      <option value='name_a_z'>Name: A to Z</option>
                      <option value='name_z_a'>Name: Z to A</option>
                      <option value='price_low_high'>Price: Low to High</option>
                      <option value='price_high_low'>Price: High to Low</option>
                    </select>
                  </div>

                  <div>
                    <label className='text-sm font-semibold block'>Type</label>
                    <select
                      value={extrasType}
                      onChange={(e) => setExtrasType(e.target.value)}
                      className='w-full mt-1 pl-2 py-1 bg-white rounded-md border border-gray-300 text-black text-sm'
                    >
                      <option value=''>Type</option>
                      <option value='Single'>Single</option>
                      <option value='Combo'>Combo</option>
                    </select>
                  </div>
                  <button
                    onClick={() => setShowFilters(false)}
                    className='px-4 w-[70%] mx-auto py-1 font-bold bg-buttonprimary text-white text-center rounded-md hover:bg-buttonhoverPrimary transition-colors'
                  >
                    Ok
                  </button>
                </div>
              )}

              <RequestForCustomization sectionName={'Extras'} />
            </div>
          </div>

          {renderExtras()}
        </section>
      </main>
      {selectedExtras && (
        <motion.div
          className='fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50 overflow-y-auto'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div transition={{ duration: 0.3, ease: 'easeOut' }}>
            <ProductDetailsPopupWithCount
              id={selectedExtras.id}
              title={selectedExtras.name}
              price={selectedExtras.price}
              image={selectedExtras.image_urls}
              description={selectedExtras.description}
              items={selectedExtras.items || []}
              type='extras'
              nextPage='cart'
              details={selectedExtras.details}
              onClose={() => setSelectedExtras(null)}
              cartItems={cartItems}
              fromCartEdit={state?.fromCartEdit || false}
              currentItemId={state?.currentItemId}
            />
          </motion.div>
        </motion.div>
      )}
      <div className='flex overflow-hidden font-normal mt-10 text-base flex-col items-center'>
        <Newsletter />
      </div>
      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
};

function SearchBar({ onSearch }) {
  return (
    <div className='relative'>
      <input
        type='text'
        placeholder='Search...'
        onChange={(e) => onSearch(e.target.value)}
        className='lg:w-56 w-full pl-8 pr-4 lg:py-1 py-2 rounded-full text-black focus:outline-none border border-gray-300 text-sm'
        aria-label='Search'
      />
      <FiSearch className='absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-700 text-base' />
    </div>
  );
}

export default ExtrasMakeup;
